import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {TalkingType} from './talkings';

export interface ModalMeetingInterface {
  state: 'open' | 'close' | ''
  room: TalkingType | null
}

// Stateの初期状態
const initialState: ModalMeetingInterface = {
  state: '',
  room : null
};

// Sliceを生成する
const slice = createSlice({
  name    : 'modal-meeting',
  initialState,
  reducers: {
    open     : (state) => {
      return {...state, state: 'open'};
    },
    close    : (state) => {
      return {...state, state: 'close'};
    },
    setRoom  : (state, action: PayloadAction<any>) => {
      return {...state, room: action.payload};
    },
    clearRoom: (state) => {
      return {...state, room: null};
    },
  }
});

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const {open, close, setRoom, clearRoom} = slice.actions;
